<template>
  <div>
    <v-subheader v-if="showGroupParent"><v-icon>{{ group.icon }}</v-icon>{{ group.title }}</v-subheader>
    <template v-for="(item, i) in group.children">
      <template v-if="showGroupParent" >
        <v-list-item
          v-if="getUserInformation.permissions
            .findIndex(permission => permission.includes(item.permission)) > -1"
          :key="i"
          :to="item.to"
          exact
          @click="menuActionClick(item.title)"
        >
          <v-list-item-icon>

          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
   </template>
  </div>
</template>

<style lang="scss">
  .theme--dark.v-subheader {
    font-size: 18px!important;
    color: #030303!important;
    padding-left: 30px!important;
  }
  .v-navigation-drawer__content .v-list .v-icon {
    font-size: 26px!important;
    color: #030303!important;
    padding-right: 5px!important;
  }
  .v-navigation-drawer__content .v-list-item__title{
    font-size: 18px!important;
    font-weight: normal;
    color: #030303!important;
    padding: 5px!important;
    
  }
  .theme--light.v-subheader {
    font-size: 18px!important;
    font-weight:bold;
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'MenuList',
  props: {
    group: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('auth',[
      'getUserInformation',
      'getUserToken'
    ]),
    showGroupParent () {
        if (Object.keys(this.getUserInformation).includes('permissions') && this.group.permission) {
            return this.getUserInformation.permissions
            .findIndex(permission => permission.includes(this.group.permission)) > -1
        } else {
          console.log('no userinfo','showGroupParent')
        }
        return false
    }
  },
  methods: {
    ...mapMutations('auth',['setCurrentFunction']),
    menuActionClick(functionName){
      this.setCurrentFunction(functionName);
    }
  }
}
</script>
